export {default as ExtendOutbound} from './view-history'
